export default __webpack_public_path__ + "static/media/Inter-UI-ExtraLight-BETA.b51a5a34.woff";